/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gray_Best_Elk_PetInputs */

const es_gray_best_elk_pet = /** @type {(inputs: Gray_Best_Elk_PetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`	Estamos encantados de que te unas a nuestra comunidad. Por favor comprueba tu email
								para verificar tu cuenta.`)
};

const gl_gray_best_elk_pet = /** @type {(inputs: Gray_Best_Elk_PetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`	Estamos encantados de que te unas á nosa comunidade. Consulte o seu correo electrónico
para verificar a súa conta.`)
};

const en_gray_best_elk_pet = /** @type {(inputs: Gray_Best_Elk_PetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`	We are delighted to have you join our community. Please check your email
to verify your account.`)
};

/**
* | output |
* | --- |
* | "We are delighted to have you join our community. Please check your email to verify your account." |
*
* @param {Gray_Best_Elk_PetInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gray_best_elk_pet = /** @type {((inputs?: Gray_Best_Elk_PetInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gray_Best_Elk_PetInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gray_best_elk_pet(inputs)
	if (locale === "en") return en_gray_best_elk_pet(inputs)
	return es_gray_best_elk_pet(inputs)
});